import { render } from "./SaleDetailView.vue?vue&type=template&id=9168caa2&scoped=true"
import script from "./SaleDetailView.vue?vue&type=script&lang=js"
export * from "./SaleDetailView.vue?vue&type=script&lang=js"

import "./SaleDetailView.vue?vue&type=style&index=0&id=9168caa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9168caa2"]])

export default __exports__